module.exports = __webpack_public_path__ + "static/media/flashlight.c413bfe6.svg";